import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartO } from "@fortawesome/free-regular-svg-icons";
import { faCartArrowDown, faCartPlus, faCartShopping, faHeart } from "@fortawesome/free-solid-svg-icons";
import { ellipsizetext } from "../../_helpers/ellipsize";
import { formatImageUrl } from "../../_helpers/route-image";

export const ItemCard = ({ item, onClick, onCartAdd, onLike, cart, wishList }) => {
    const computeDiscount = (price, percentage) => {
        return parseInt(price) - price * parseFloat(percentage);
    }

    const isNew = (item) => {
        const twoWeeks = 14 * 24 * 60 * 60 * 1000;
        const today = new Date();
        const thatDay = new Date(item.newArrival);

        return today - thatDay < twoWeeks;
    }

    const { original_cost, discount } = item?.pricing;

    return (
        <div>
            <button
                className="wish-button"
                onClick={onLike}
            >
                <FontAwesomeIcon
                    icon={wishList?.some((elem) => elem?._id === item?._id) ? faHeart : faHeartO}
                />
            </button>
            <button
                className="cart-add-button"
                onClick={onCartAdd}
            >
                <FontAwesomeIcon
                    icon={faCartShopping}
                />
            </button>
            {isNew(item) && <button className="new-sticker">Nouveauté</button>}
            <button
                className="item-container"
                key={item._id}
                onClick={onClick}
            >

                
                <img src={formatImageUrl(item.images[0])} alt="" className="item-img" />
                <span className="item-info">
                    <span className="item-brand">{item.brand}</span>
                    <span className="item-name">{item.designation}</span>
                    {discount > 0 && <span className="discount-perc">{"-"}{discount * 100}{"%"}</span>}
                    <span className="bottom-section">
                        {discount > 0 &&
                            (<strike>
                                <span className="discount-text">
                                    {original_cost} FCFA
                                </span>
                            </strike>)}

                        <span className="item-cost">
                            {original_cost - original_cost * discount} FCFA
                        </span>
                    </span>
                </span>
                <span className="more-bottom">
                    <span
                        className="more-button"
                        onClick={onClick}
                    >
                        <span className="more-text">Voir Produit</span>
                    </span>
                </span>
            </button>
        </div>
    )
}